import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  BaseComponent,
  FormService,
  GridComponent,
  GridRowSelect,
  GridService,
  NotificationService,
} from '../../../../tms-shared';
import { RoleService } from '../../services';
import { RoleMenuItem, UpdateRoleMenuItem } from '../../models';

@Component({
  selector: 'app-role-menu-items',
  templateUrl: './role-menu-items.component.html',
  styleUrl: './role-menu-items.component.scss',
})
export class RoleMenuItemsComponent extends BaseComponent implements OnInit {
  @ViewChild(GridComponent) grid: GridComponent;

  columnDefs: ColDef[] = [
    ...this.gridService.checkboxRowSelect('name', $localize`Name`),
    this.gridService.checkbox('readOnly', $localize`Read Only`, (model: RoleMenuItem) => model.selected),
    this.gridService.text('groupName', $localize`Group Name`),
  ];

  rowData$: Observable<RoleMenuItem[]>;

  private roleId: string;

  constructor(
    private roleService: RoleService,
    private gridService: GridService,
    private formService: FormService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit(): void {
    this.roleId = this.route.snapshot.paramMap.get('id');
    this.getModel();
  }

  rowSelected(event: GridRowSelect) {
    if (!event.selected) {
      event.node.setDataValue('readOnly', false);
    }
  }

  save() {
    this.formService.beginSave();
    this.roleService
      .updateRoleMenuItems(
        this.roleId,
        this.grid.selectedRows.map(
          (x: RoleMenuItem) => ({ menuItemId: x.id, readOnly: x.readOnly }) as UpdateRoleMenuItem,
        ),
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.notificationService.saveSuccess($localize`Role Menus`);
          this.getModel();
          this.formService.endSave(false);
        },
        error: () => {
          this.notificationService.saveFail($localize`Role Menus`);
          this.formService.endSave(true);
        },
      });
  }

  private getModel() {
    this.rowData$ = this.roleService.getRoleMenuItems(this.roleId);
    this.grid?.resetEdited();
  }
}
